import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Heading, Text } from '@leroy-merlin-br/backyard-react-ui'

const contentWrapperStyles = ({ theme }) => css`
  label: modal;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  padding: ${theme.spacings.exa};
`

const modalTitleStyles = ({ theme }) => css`
  color: ${theme.colors.n800};
`

const modalTextStyles = ({ theme }) => css`
  color: ${theme.colors.n500};
`

export const ContentWrapper = styled('div')(contentWrapperStyles)
export const ModalTitle = styled(Heading)(modalTitleStyles)
export const ModalText = styled(Text)(modalTextStyles)
